export const categories = [
  { id: 'pure-love', name: '纯爱系', slug: 'pure-love', icon: 'ri-heart-line', description: '以真挚情感为核心的纯爱系里番作品，描绘角色间纯洁而深刻的情感羁绊。纯爱系作品注重角色心理描写与情感发展过程，画面唯美细腻，适合追求情感共鸣的观众。', color: 'primary' },
  { id: 'harem', name: '后宫系', slug: 'harem', icon: 'ri-group-line', description: '围绕一位主角与多位异性角色展开的后宫系作品，融合喜剧、恋爱与日常元素。角色性格鲜明各异，剧情轻松有趣，是里番领域最受欢迎的类型之一。', color: 'accent' },
  { id: 'fantasy', name: '奇幻系', slug: 'fantasy', icon: 'ri-magic-line', description: '以异世界、魔法、神话传说为舞台的奇幻系里番作品。天马行空的想象力构建出独特的世界观，在异色幻想中探索人性与欲望的边界。', color: 'secondary' },
  { id: 'school', name: '校园系', slug: 'school', icon: 'ri-building-line', description: '以校园为故事背景的校园系作品，贴近青春回忆的叙事风格让观众产生强烈代入感。从教室到社团活动，校园场景承载着丰富的情感故事。', color: 'primary' },
  { id: 'yuri', name: '百合系', slug: 'yuri', icon: 'ri-women-line', description: '专注于女性角色间情感与关系的百合系作品，以细腻笔触描绘同性之间的爱恋与羁绊。画面风格柔美精致，情感表达深刻动人。', color: 'accent' },
  { id: 'ntr', name: 'NTR系', slug: 'ntr', icon: 'ri-emotion-sad-line', description: '以感情背叛与占有为主题的NTR系作品，通过强烈的情感冲突与心理挣扎营造戏剧张力。适合喜欢复杂情感纠葛与深度心理描写的观众。', color: 'secondary' },
  { id: 'bdsm', name: '调教系', slug: 'bdsm', icon: 'ri-links-line', description: '探索权力关系与感官边界的调教系里番作品。通过精心设计的情节与角色互动，展现支配与服从之间微妙的心理变化与情感流动。', color: 'primary' },
  { id: 'sci-fi', name: '科幻系', slug: 'sci-fi', icon: 'ri-rocket-line', description: '融合未来科技、人工智能与赛博朋克元素的科幻系里番。在科技高度发达的未来世界中，重新审视人性、欲望与伦理的边界。', color: 'accent' },
];

export const articles = [
  {
    id: 1,
    title: '《漆黑的射干》——纯爱系经典之作的深度解析',
    slug: 'black-lilith-pure-love-analysis',
    category: '纯爱系',
    categorySlug: 'pure-love',
    thumbnail: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20style%20illustration%20of%20romantic%20couple%20in%20cherry%20blossom%20garden%2C%20warm%20soft%20lighting%2C%20emotional%20atmosphere%2C%20delicate%20art%20style%2C%20cinematic%20composition%2C%20pink%20and%20white%20color%20palette%2C%20beautiful%20anime%20aesthetic&width=800&height=500&seq=article-thumb-01&orientation=landscape',
    author: '夜桜编辑部',
    date: '2026-07-20',
    readTime: 8,
    excerpt: '作为Lilith旗下最具代表性的纯爱系里番，《漆黑的射干》以其精良的制作水准与深刻的情感刻画，在里番史上留下了浓墨重彩的一笔。本文将从剧情结构、角色塑造、美术风格等多个维度进行全面解析。',
    tags: ['纯爱', 'Lilith', '经典推荐', '剧情解析'],
    featured: true,
    trending: true,
    content: `
      <h2>作品概览</h2>
      <p>《漆黑的射干》是由日本知名成人动画制作公司Lilith于2015年推出的纯爱系里番作品。该作以其精致的作画质量、细腻的情感描写和完整的叙事结构，迅速在里番爱好者群体中获得极高评价，被誉为"纯爱系里番的里程碑之作"。</p>
      <p>作品讲述了在江户时代背景下，一位名叫射干的年轻艺伎与她的恋人在动荡时代中坚守爱情的故事。与传统里番不同，本作将情感刻画放在了与成人内容同等重要的位置，甚至在某些段落中，情感的表达超越了对感官刺激的追求。</p>
      
      <h2>剧情结构分析</h2>
      <p>《漆黑的射干》采用了三幕剧结构，剧情推进自然流畅。第一幕建立世界观与角色关系，通过日常互动展现主角间的感情基础；第二幕引入冲突，时代动荡考验着两人的感情；第三幕则走向情感的高潮与解决。</p>
      <p>值得称道的是，剧本没有为了服务于成人内容而牺牲叙事的完整性。每一段亲密场景都承载着推进剧情或深化角色关系的作用，实现了剧情与成人内容的有机统一。</p>
      
      <h2>角色塑造</h2>
      <p>女主角射干的角色塑造堪称里番作品中的典范。她并非传统意义上的被动角色，而是有着独立意志与情感深度的立体人物。从最初的内敛含蓄到后期为爱勇敢抗争，角色弧光完整而动人。</p>
      <p>男主角的形象同样经过精心打磨，突破了里番作品中常见的"工具人"定位，展现出令人信服的人格魅力与情感深度。</p>
      
      <h2>美术风格与技术特色</h2>
      <p>Lilith在本作中展现了其一贯的精湛作画水准。人物设计兼具美感与辨识度，服装与场景细节的刻画极为考究。江户时代的建筑、服饰、器物都在考据的基础上进行了艺术化的呈现。</p>
      <p>色彩运用上，作品采用了柔和而富有层次感的色调，在关键情感场景中通过光影变化强化情绪表达。动画帧数充足，角色动作流畅自然，尤其在情感交流的场景中，微表情与肢体语言的细腻表现令人印象深刻。</p>
      
      <h2>音乐与配音</h2>
      <p>背景音乐由资深作曲家操刀，融合了传统日本乐器与现代编曲手法。主题旋律优美而略带忧伤，与作品的整体基调高度契合。配音演员的表现同样出色，尤其是女主角声优对角色内心情感变化的精准把握，为角色注入了灵魂。</p>
      
      <h2>文化价值与影响</h2>
      <p>《漆黑的射干》的成功证明了在里番领域中，高质量的故事内容同样能够获得市场认可。它在一定程度上推动了业界对作品质量的重视，影响了后续一批注重剧情与情感刻画的纯爱系里番作品的创作方向。</p>
      
      <h2>观看建议</h2>
      <p>本作适合喜欢细腻情感描写与精良制作的观众。建议在安静的环境中完整观看，以便充分感受作品的情感层次。需要注意的是，本作包含成人内容，仅适合18岁以上观众观看。建议通过正规渠道获取观看权限。</p>
    `,
  },
  {
    id: 2,
    title: '后宫系里番进化史：从《无颜之月》到当代名作',
    slug: 'harem-anime-evolution-history',
    category: '后宫系',
    categorySlug: 'harem',
    thumbnail: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20style%20illustration%20of%20multiple%20anime%20characters%20gathered%20around%20one%20person%2C%20comedic%20romance%20atmosphere%2C%20bright%20colorful%20style%2C%20slice%20of%20life%20vibe%2C%20clean%20art%20style%2C%20warm%20lighting&width=800&height=500&seq=article-thumb-02&orientation=landscape',
    author: '里番研究所',
    date: '2026-07-15',
    readTime: 10,
    excerpt: '后宫系作为里番中最受欢迎的分类之一，经历了从早期简单设定到如今复杂叙事的演变。本文将梳理后宫系里番的发展历程，解析各个时期的代表作品与风格变迁。',
    tags: ['后宫', '发展史', '经典作品', '行业分析'],
    featured: true,
    trending: true,
    content: `
      <h2>后宫系的定义与起源</h2>
      <p>后宫系（ハーレムもの）是日本ACG文化中的重要类型，其核心特征是围绕一位主角与多位异性角色之间的互动展开故事。在里番领域，后宫系作品在继承这一基本设定的同时，更加注重角色间情感与欲望的深度探索。</p>
      <p>后宫系里番的起源可以追溯到1990年代初期。这一时期的作品虽然在制作规格上相对有限，但已经奠定了后宫系的基本叙事模式：一位男主角因某种机缘巧合，与多位性格各异的女性角色产生交集。</p>
      
      <h2>黄金时期：2000年代的爆发</h2>
      <p>进入2000年代，随着动画制作技术的提升和DVD市场的成熟，后宫系里番迎来了创作高峰。《无颜之月》等作品以其精良的制作质量与丰富的剧情内容，成为这一时期的标杆之作。</p>
      <p>这一时期的作品开始注重角色差异化塑造，每位女性角色都被赋予独特的性格特征与背景故事。观众可以根据自己的喜好找到共鸣的角色，这也是后宫系作品广受欢迎的重要原因。</p>
      
      <h2>现代后宫系的多元化发展</h2>
      <p>2010年代后，后宫系里番呈现出明显的多元化趋势：</p>
      <ul>
        <li><strong>异世界后宫：</strong>以奇幻世界为舞台，主角通过特殊能力或身份吸引多位异性角色的关注。</li>
        <li><strong>学园后宫：</strong>以校园为背景，在日常学习生活中展开的多角关系故事。</li>
        <li><strong>职场后宫：</strong>以工作场所为舞台，在职业背景下发展的复杂人际关系。</li>
        <li><strong>逆后宫：</strong>将性别角色反转，以女主角为中心展开的故事。</li>
      </ul>
      
      <h2>代表作品推荐</h2>
      <p>对于希望深入了解后宫系里番的观众，以下作品可以作为入门参考：</p>
      <p>《无颜之月》——后宫系的开创性作品，奠定了该类型的基本叙事框架。<br/>
      《夜勤病栋》——将医疗题材与后宫设定相结合的代表作，角色关系错综复杂。<br/>
      《异世界后宫物语》——融合奇幻元素的后宫系新作，在世界观构建上有独到之处。</p>
      
      <h2>未来趋势展望</h2>
      <p>随着观众审美的提升和制作技术的进步，后宫系里番正在向更加注重故事质量与角色深度的方向发展。单纯的"数量堆砌"已经无法满足当代观众的需求，如何在保持后宫系魅力的同时提升作品的艺术水准，是业界面临的重要课题。</p>
    `,
  },
  {
    id: 3,
    title: '奇幻系里番世界观构建指南：从《对魔忍》说起',
    slug: 'fantasy-anime-world-building-guide',
    category: '奇幻系',
    categorySlug: 'fantasy',
    thumbnail: 'https://readdy.ai/api/search-image?query=Dark%20fantasy%20anime%20style%20illustration%20of%20magical%20warrior%20in%20mystical%20landscape%2C%20dramatic%20lighting%2C%20gothic%20atmosphere%2C%20sword%20and%20sorcery%20theme%2C%20detailed%20armor%20design%2C%20epic%20composition&width=800&height=500&seq=article-thumb-03&orientation=landscape',
    author: '幻想文库',
    date: '2026-07-10',
    readTime: 12,
    excerpt: '奇幻系里番以其丰富的想象力与独特的世界观构建而独树一帜。本文以经典作品《对魔忍》为切入点，深入分析奇幻系里番在世界观设计、魔法体系与角色设定方面的创作方法论。',
    tags: ['奇幻', '对魔忍', '世界观', '创作分析'],
    featured: false,
    trending: true,
    content: `
      <h2>奇幻系里番的魅力所在</h2>
      <p>奇幻系里番最大的魅力在于其不受现实约束的想象力。在魔法与异世界的大背景下，创作者可以摆脱日常场景的限制，构建出独一无二的故事舞台。这种自由度赋予了奇幻系作品独特的艺术生命力和表达空间。</p>
      <p>《对魔忍》系列作为奇幻系里番的代表作，成功构建了一个融合现代都市与魔幻元素的独特世界观。在这个世界中，拥有特殊能力的"对魔忍"与来自魔界的威胁展开对抗，为观众呈现了一场视觉与想象力的盛宴。</p>
      
      <h2>世界观构建的核心要素</h2>
      <p>优秀的奇幻系里番在世界观构建上有以下几个共同特征：</p>
      <p><strong>1. 自洽的力量体系：</strong>魔法、超能力或特殊技能需要有清晰的规则与限制。力量体系的合理性直接影响作品的可信度与观众的沉浸感。</p>
      <p><strong>2. 丰富的种族设定：</strong>从精灵、魔族到兽人，多元的种族构成拓展了叙事的可能性，也为角色间的互动提供了更多戏剧冲突的来源。</p>
      <p><strong>3. 历史纵深：</strong>赋予世界观以历史背景，通过古老的传说、遗迹或文献，增强世界的真实感与厚度。</p>
      
      <h2>《对魔忍》世界观的深度解析</h2>
      <p>《对魔忍》的世界观设计展现了极高的完成度。作品巧妙地将现代社会与魔幻元素交织在一起，创造出一个既熟悉又陌生的独特舞台。</p>
      <p>在这个世界中，"对魔忍"这一职业的设定极具创意——她们既是隐藏在普通人中的忍者，又是对抗超自然威胁的战士。这种双重身份的设定创造了丰富的戏剧可能性，也是作品魅力的重要来源。</p>
      
      <h2>推荐奇幻系作品</h2>
      <p>对于喜欢奇幻系里番的观众，以下作品值得关注：<br/>
      《对魔忍》系列——奇幻系标杆之作，世界观完整<br/>
      《魔界骑士》——中世纪奇幻风格的优秀代表<br/>
      《战乙女》系列——北欧神话背景的史诗级作品<br/>
      《异世界迷宫》——近年来的热门奇幻系新作</p>
      
      <h2>创作启示</h2>
      <p>奇幻系里番的成功经验表明，即使在成人内容领域，优秀的世界观构建和故事讲述依然是最核心的竞争力。创作者应当重视世界观的完整性和自洽性，让成人内容服务于故事，而非相反。</p>
    `,
  },
  {
    id: 4,
    title: '校园系里番推荐：青春与欲望交织的十部必看作品',
    slug: 'school-anime-top-10-recommendations',
    category: '校园系',
    categorySlug: 'school',
    thumbnail: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20style%20illustration%20of%20school%20classroom%20with%20students%20in%20uniforms%2C%20sunset%20lighting%20through%20windows%2C%20nostalgic%20atmosphere%2C%20youthful%20romance%20vibe%2C%20warm%20golden%20hour%20glow%2C%20slice%20of%20life%20aesthetic&width=800&height=500&seq=article-thumb-04&orientation=landscape',
    author: '夜桜编辑部',
    date: '2026-07-05',
    readTime: 9,
    excerpt: '校园系里番因其贴近生活的叙事而拥有广泛的观众群。本文精选十部校园系里番佳作，涵盖不同风格与主题，为观众提供全面的选片参考。',
    tags: ['校园', '推荐合集', 'TOP10', '观影指南'],
    featured: false,
    trending: false,
    content: `
      <h2>校园系里番的独特魅力</h2>
      <p>校园系里番之所以长盛不衰，在于它唤起了观众对青春岁月的集体记忆与情感共鸣。教室、走廊、社团活动室、学校天台——这些熟悉的场景承载着每个人关于成长的独特体验。当成人内容被放置在这些日常场景中时，它所产生的代入感与情感冲击力是其他分类难以比拟的。</p>
      
      <h2>TOP 10 校园系里番推荐</h2>
      
      <h3>第1位：《教室的角落》</h3>
      <p>以独特的叙事视角展现了校园生活中不为人知的一面。细腻的情感刻画与精致的画面表现力使其成为校园系里番的标杆之作。</p>
      
      <h3>第2位：《放学后的秘密》</h3>
      <p>围绕学校社团活动展开的多线叙事，角色性格鲜明，剧情节奏把控精准。</p>
      
      <h3>第3位：《夏日教室》</h3>
      <p>以炎热夏季的补习班为舞台，通过细腻的环境描写与心理刻画，营造出独特的氛围感。</p>
      
      <h3>第4位：《学园默示录》</h3>
      <p>大胆融合了校园与末世生存元素，在紧张的生存压力下展现角色间复杂的情感互动。</p>
      
      <h3>第5位：《青春期的探索》</h3>
      <p>聚焦青少年心理成长与性意识觉醒的写实风格作品，具有较高的人文关怀价值。</p>
      
      <h3>第6-10位</h3>
      <p>《学生会室物语》《体育仓库的午后》《校园祭之夜》《毕业前的约定》《转校生》——这五部作品各具特色，从不同角度呈现了校园系里番的丰富面貌。</p>
      
      <h2>如何选择适合自己的作品</h2>
      <p>校园系里番风格多样，建议根据自己的偏好选择：喜欢轻松喜剧的观众可以选择日常搞笑风格的作品；追求情感深度的观众可以关注注重心理描写的作品；喜欢独特设定的观众则可以尝试融合奇幻或悬疑元素的校园系作品。</p>
    `,
  },
  {
    id: 5,
    title: '百合系里番入门指南：从《少女派别》到当代名作',
    slug: 'yuri-anime-beginners-guide',
    category: '百合系',
    categorySlug: 'yuri',
    thumbnail: 'https://readdy.ai/api/search-image?query=Beautiful%20anime%20style%20illustration%20of%20two%20girls%20holding%20hands%20in%20flower%20garden%2C%20soft%20pastel%20color%20palette%2C%20gentle%20romantic%20atmosphere%2C%20watercolor%20art%20style%2C%20dreamy%20lighting%2C%20emotional%20connection&width=800&height=500&seq=article-thumb-05&orientation=landscape',
    author: '里番研究所',
    date: '2026-06-28',
    readTime: 11,
    excerpt: '百合系里番以其独特的审美风格与细腻的情感刻画，在里番爱好者中拥有忠实的受众。本文为初次接触百合系里番的观众提供全面的入门指南。',
    tags: ['百合', '入门指南', '推荐', '文化解析'],
    featured: true,
    trending: false,
    content: `
      <h2>百合系里番的定义</h2>
      <p>百合系里番专注于描绘女性角色之间的情感与关系。与普通恋爱系作品不同，百合系在情感表达上往往更加细腻含蓄，注重氛围的营造与心理的刻画。这种独特的审美取向使百合系在里番领域中占据了不可替代的位置。</p>
      
      <h2>百合系的发展脉络</h2>
      <p>百合文化在日本有着悠久的历史渊源。从大正时代的少女文学到战后的少女漫画，再到如今的动画与游戏，百合题材经历了从边缘到主流的发展过程。在里番领域，《少女派别》等开创性作品为百合系里番的发展奠定了基础。</p>
      
      <h2>经典作品解析</h2>
      <p>《少女派别》——作为百合系里番的里程碑之作，作品以其精美的画面与深刻的情感刻画赢得了广泛好评。故事围绕女校中的少女们展开，展现了她们之间复杂而真挚的情感羁绊。</p>
      <p>《花吻在上》——改编自同名人气游戏，作品在保持游戏原作温馨氛围的同时，通过动画的表现力进一步增强了情感的感染力。</p>
      
      <h2>当代百合系里番推荐</h2>
      <p>近年来，百合系里番在制作质量与题材多样性上都有了显著提升。以下作品展现了当代百合系里番的发展方向：</p>
      <p>《百合之夏》——以海滨小镇为舞台的青春物语<br/>
      《秘密的花园》——融合悬疑元素的百合系创新之作<br/>
      《两个人的时间》——聚焦日常生活的温馨风格作品</p>
      
      <h2>百合系里番的审美特征</h2>
      <p>百合系里番在视觉风格上通常具有以下特征：柔和的色彩运用、细腻的人物描绘、注重光影氛围的营造。这些视觉特征与百合系作品追求的情感温度高度契合，形成了独特的审美体验。</p>
    `,
  },
  {
    id: 6,
    title: 'NTR系里番：情感冲突的极致表达与心理深度',
    slug: 'ntr-anime-emotional-depth-analysis',
    category: 'NTR系',
    categorySlug: 'ntr',
    thumbnail: 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20anime%20style%20illustration%20of%20emotional%20conflict%20scene%2C%20rainy%20atmosphere%2C%20melancholic%20mood%2C%20complex%20emotions%2C%20cinematic%20lighting%2C%20deep%20shadows%2C%20intense%20psychological%20drama%20aesthetic&width=800&height=500&seq=article-thumb-06&orientation=landscape',
    author: '夜桜编辑部',
    date: '2026-06-20',
    readTime: 10,
    excerpt: 'NTR系里番以其强烈的情感冲击力和复杂的心理描写而著称。本文将深入分析NTR系作品的叙事结构、情感表达方式及其在里番文化中的独特地位。',
    tags: ['NTR', '情感分析', '心理学', '深度解读'],
    featured: false,
    trending: false,
    content: `
      <h2>理解NTR系里番</h2>
      <p>NTR（寝取られ）系里番是日本成人动画中最具争议也最具情感冲击力的分类之一。其核心叙事围绕"感情背叛"展开，通过描绘角色在情感冲突中的挣扎与痛苦，激发观众强烈的情感共鸣。</p>
      <p>需要明确的是，NTR系作品的魅力不在于背叛行为本身，而在于它所创造的情感张力和心理深度。优秀的NTR系作品能够让观众在情感冲击中反思人性、欲望与道德的复杂关系。</p>
      
      <h2>NTR系作品的叙事结构</h2>
      <p>经典的NTR叙事通常包含以下阶段：建立情感基础（让观众对原配关系产生认同）→ 引入威胁（第三方介入）→ 情感动摇与挣扎 → 关系破裂或重建。这种结构设计精准地操控着观众的情感走向。</p>
      
      <h2>心理描写的深度</h2>
      <p>NTR系作品最突出的艺术价值在于其对人心理深度的探索。角色在面对诱惑、内疚、嫉妒、愤怒等复杂情绪时的心理变化，构成了NTR作品最引人入胜的部分。</p>
      
      <h2>代表作品与风格差异</h2>
      <p>《真·瑠璃色之雪》——被誉为NTR系里番的经典之作，以其深刻的角色刻画和完整的故事结构著称。<br/>
      《告白》——以现代都市为背景的NTR作品，在情感表达上更加克制内敛。<br/>
      《背德之恋》——在传统NTR框架下加入社会议题探讨的创新之作。</p>
      
      <h2>观看NTR作品的心理准备</h2>
      <p>NTR系作品可能会给部分观众带来强烈的情感不适，建议在观看前做好心理预期。如果发现自己对这类内容产生过度负面情绪，应当及时停止观看，选择其他类型的作品。</p>
    `,
  },
  {
    id: 7,
    title: '调教系里番：权力关系的艺术化表达',
    slug: 'bdsm-anime-power-dynamics-art',
    category: '调教系',
    categorySlug: 'bdsm',
    thumbnail: 'https://readdy.ai/api/search-image?query=Mysterious%20elegant%20anime%20style%20illustration%20of%20luxurious%20interior%20with%20dramatic%20lighting%2C%20gothic%20aesthetic%2C%20refined%20atmosphere%2C%20dark%20academia%20vibe%2C%20ornate%20details%2C%20sophisticated%20composition&width=800&height=500&seq=article-thumb-07&orientation=landscape',
    author: '幻想文库',
    date: '2026-06-15',
    readTime: 9,
    excerpt: '调教系里番通过权力关系的建立与转化，探索了人性深处的欲望结构。本文将从心理学与美学角度，剖析调教系作品的艺术表达方式与文化内涵。',
    tags: ['调教', '权力关系', '心理学', '美学分析'],
    featured: false,
    trending: false,
    content: `
      <h2>调教系作品的本质</h2>
      <p>调教系里番的核心并非表面的感官刺激，而是对权力关系的艺术化探索。通过角色间支配与服从的互动，作品展现了人性中关于控制、信任与解放的深层欲望结构。</p>
      
      <h2>权力关系的动态演变</h2>
      <p>优秀的调教系作品会展现权力关系的动态演变过程——从最初的对立与抗拒，到逐渐建立的信任与默契，再到关系的深化与转化。这一过程承载着丰富的情感层次与心理变化，是调教系作品最值得关注的叙事内容。</p>
      
      <h2>视觉美学</h2>
      <p>调教系里番在视觉风格上往往追求精致与奢华感。场景设计注重细节与氛围，服装设计兼具美感与象征意义，光影运用强化情绪表达——这些视觉元素的精心安排，使调教系作品在美学层面具有独特的观赏价值。</p>
      
      <h2>代表作品</h2>
      <p>《奴隶市场》——以中世纪奇幻世界为舞台的经典调教系作品<br/>
      《女教师》系列——在现代背景下探讨权力关系的佳作<br/>
      《笼中的小鸟》——注重心理描写与情感发展的调教系新作</p>
    `,
  },
  {
    id: 8,
    title: '科幻系里番：赛博朋克世界中的欲望探索',
    slug: 'sci-fi-anime-cyberpunk-desire',
    category: '科幻系',
    categorySlug: 'sci-fi',
    thumbnail: 'https://readdy.ai/api/search-image?query=Futuristic%20cyberpunk%20anime%20style%20cityscape%20with%20neon%20lights%20and%20holograms%2C%20dark%20atmosphere%2C%20high%20tech%20aesthetic%2C%20blade%20runner%20vibe%2C%20rainy%20street%2C%20dystopian%20future%2C%20detailed%20sci-fi%20architecture&width=800&height=500&seq=article-thumb-08&orientation=landscape',
    author: '里番研究所',
    date: '2026-06-08',
    readTime: 8,
    excerpt: '当科技高度发达的未来社会与人类原始的欲望相遇，科幻系里番为我们提供了一个独特的思考视角。本文探讨科幻系里番如何利用科技元素重新诠释传统欲望主题。',
    tags: ['科幻', '赛博朋克', '未来主义', '科技伦理'],
    featured: false,
    trending: false,
    content: `
      <h2>科幻与欲望的交汇</h2>
      <p>科幻系里番是里番领域中最具创新性的分类之一。通过引入人工智能、虚拟现实、基因改造等科技元素，这一类型的作品得以在全新的维度上探讨人类欲望的本质。</p>
      
      <h2>科技作为欲望的放大器</h2>
      <p>在科幻系里番中，科技往往不是单纯的背景设定，而是欲望表达的催化剂与放大器。虚拟现实技术让人们可以体验超越现实的感官刺激；人工智能引发了对"意识"与"情感"的深层思考；基因改造则模糊了自然与人工的边界。</p>
      
      <h2>赛博朋克美学</h2>
      <p>科幻系里番在视觉风格上深受赛博朋克美学的影响：霓虹灯点缀的雨夜街道、巨型企业控制的反乌托邦社会、高科技与低生活并存的矛盾画面。这种视觉风格与作品探讨的主题——科技时代的人性困境——形成了完美的呼应。</p>
      
      <h2>推荐作品</h2>
      <p>《电脳少女》——以人工智能觉醒为主题的划时代作品<br/>
      《机械纪元》——融合动作元素与成人内容的科幻力作<br/>
      《虚拟乐园》——探讨虚拟现实技术伦理的前瞻性作品</p>
    `,
  },
  {
    id: 9,
    title: '里番动漫制作流程揭秘：从企划到成片的完整指南',
    slug: 'hentai-anime-production-process',
    category: '纯爱系',
    categorySlug: 'pure-love',
    thumbnail: 'https://readdy.ai/api/search-image?query=Anime%20production%20studio%20workspace%20with%20drawing%20tablet%20and%20storyboards%2C%20creative%20art%20environment%2C%20illustrator%20workspace%2C%20warm%20desk%20lamp%20lighting%2C%20professional%20animation%20tools%2C%20organized%20creative%20chaos&width=800&height=500&seq=article-thumb-09&orientation=landscape',
    author: '里番研究所',
    date: '2026-05-30',
    readTime: 15,
    excerpt: '你是否好奇一部里番动画是如何从无到有制作出来的？本文带你走进里番动画制作的幕后，从企划立案、角色设计、分镜绘制到后期制作的完整流程，让你全面了解这个行业的创作生态。',
    tags: ['制作流程', '行业揭秘', '幕后', '动画制作'],
    featured: true,
    trending: true,
    content: `
      <h2>企划阶段</h2>
      <p>一部里番动画的诞生始于企划立案。制作公司会根据市场调研、原作改编需求或原创构想，确定作品的基本方向。这一阶段需要明确目标受众、预算规模、制作周期等关键要素。</p>
      <p>企划书中通常包含作品的概念说明、主要角色设定、故事大纲以及初步的视觉风格参考。获得投资方或发行方的认可后，项目正式进入前期制作阶段。</p>
      
      <h2>前期制作</h2>
      <p><strong>剧本创作：</strong>由专业编剧根据企划方向撰写详细的剧本。里番的剧本写作需要在成人内容与故事性之间找到平衡，这要求编剧具备丰富的行业经验与叙事技巧。</p>
      <p><strong>角色设计：</strong>角色设计师根据剧本设定创作所有登场角色的视觉形象。包括正面、侧面、背面三视图，以及各种表情与服装变化。里番的角色设计需要在"吸引力"与"辨识度"之间取得平衡。</p>
      <p><strong>分镜绘制：</strong>导演根据剧本绘制分镜（絵コンテ），确定每个镜头的构图、动作、时间长度及音效指示。分镜是动画制作的蓝图，其质量直接影响成片的节奏与表现力。</p>
      
      <h2>中期制作</h2>
      <p><strong>原画绘制：</strong>原画师根据分镜绘制关键帧画面。作为动画品质的决定性环节，原画阶段需要原画师具备扎实的绘画功底与对运动规律的理解。里番的原画工作中，人物体态与表情的精准刻画尤为重要。</p>
      <p><strong>动画（中割）：</strong>在原画之间插入中间帧，使动作更加流畅。这一工作通常由动画师完成，部分工作会外包给海外工作室。</p>
      <p><strong>上色：</strong>对完成的线稿进行数码上色。现代动画制作中，上色工作主要使用专业软件完成。</p>
      
      <h2>后期制作</h2>
      <p><strong>背景绘制：</strong>背景美术师根据设定绘制所有场景背景。里番的背景绘制同样需要精心的设计与执行，优秀的背景能够有效提升作品的氛围感与沉浸感。</p>
      <p><strong>摄影与合成：</strong>将角色动画与背景合成，并添加光影效果、特殊效果等后期处理。</p>
      <p><strong>配音录制：</strong>声优根据剧本进行角色配音。里番的配音工作要求声优在表现情感的同时，兼顾成人内容的特殊需求。</p>
      <p><strong>音效与音乐：</strong>添加背景音乐和音效，完成最终的音频混合。</p>
      
      <h2>行业现状与挑战</h2>
      <p>里番动画行业面临着预算有限、制作周期紧张、人才流失等挑战。然而，随着数字化工具的普及和发行渠道的多元化，独立创作者和小型工作室也获得了更多的创作与发布机会。未来，技术与创作理念的进步将继续推动这个行业向前发展。</p>
    `,
  },
  {
    id: 10,
    title: '里番漫画推荐：十部不容错过的经典成人漫画',
    slug: 'hentai-manga-top-10-classics',
    category: '纯爱系',
    categorySlug: 'pure-love',
    thumbnail: 'https://readdy.ai/api/search-image?query=Collection%20of%20Japanese%20manga%20books%20on%20wooden%20shelf%2C%20warm%20reading%20nook%20atmosphere%2C%20cozy%20library%20vibe%2C%20soft%20natural%20lighting%2C%20organized%20bookshelf%2C%20reading%20culture%20aesthetic&width=800&height=500&seq=article-thumb-10&orientation=landscape',
    author: '夜桜编辑部',
    date: '2026-05-22',
    readTime: 11,
    excerpt: '在动画之外，里番漫画同样是日本成人动漫文化的重要载体。本文精选十部在艺术水准与故事内容上都有出色表现的经典里番漫画，涵盖多种风格与题材。',
    tags: ['漫画', '经典推荐', 'TOP10', '日本漫画'],
    featured: false,
    trending: false,
    content: `
      <h2>里番漫画的独特价值</h2>
      <p>相比于动画，里番漫画在创作上拥有更大的自由度。不受制作预算与时间的严格限制，漫画家可以更加深入地探索角色心理与故事细节。同时，漫画的静态画面特性使得读者可以按照自己的节奏欣赏作品的每一个细节。</p>
      
      <h2>十部经典里番漫画推荐</h2>
      
      <h3>1. 《甜蜜的惩罚》——如月群真</h3>
      <p>如月群真的代表作，以细腻的画风与深刻的情感刻画著称。作品在保持成人内容的同时，构建了令人信服的爱情故事。</p>
      
      <h3>2. 《水之色》——水无月十三</h3>
      <p>独特的色彩运用与水彩风格画面，使这部作品在视觉上独树一帜。故事围绕着水边小镇的夏日记忆展开，充满诗意与感伤。</p>
      
      <h3>3. 《恋爱的课后辅导》——TYPE.90</h3>
      <p>以校园为舞台的青春系作品，角色塑造生动自然，剧情推进张弛有度。</p>
      
      <h3>4-10位作品概览</h3>
      <p>《秘密的花园》《远距离恋爱》《夏日的约定》《午夜咖啡厅》《雪之回忆》《禁忌的游戏》《心之距离》——这七部作品各具特色，从不同角度展现了里番漫画的艺术多样性与创作活力。</p>
      
      <h2>如何获取这些作品</h2>
      <p>建议通过正规渠道如DLsite、FANZA等同人及商业漫画平台获取作品。支持正版不仅是对创作者劳动的尊重，也有助于行业的健康发展。</p>
    `,
  },
  {
    id: 11,
    title: '日本成人动漫文化发展史：从地下到主流的五十年',
    slug: 'japanese-adult-anime-culture-history',
    category: '纯爱系',
    categorySlug: 'pure-love',
    thumbnail: 'https://readdy.ai/api/search-image?query=Retro%20Japanese%20anime%20style%20illustration%20showing%20evolution%20timeline%2C%20vintage%20animation%20cels%2C%20old%20school%20anime%20aesthetic%2C%20film%20history%20theme%2C%20nostalgic%20warm%20tones%2C%20cultural%20heritage%20vibe&width=800&height=500&seq=article-thumb-11&orientation=landscape',
    author: '里番研究所',
    date: '2026-05-15',
    readTime: 18,
    excerpt: '从1970年代的地下OVA到如今的流媒体时代，日本成人动漫文化经历了半个世纪的沧桑巨变。本文全面梳理日本成人动漫文化的发展脉络，解析各个时期的社会背景、技术变革与代表作品。',
    tags: ['文化史', '行业发展', '日本动漫', '历史回顾'],
    featured: true,
    trending: false,
    content: `
      <h2>萌芽期：1970年代</h2>
      <p>日本成人动漫的雏形出现在1970年代初期。这一时期，随着日本经济的高速增长和录像带技术的普及，面向成人观众的小规模动画制作开始出现。这些早期作品在技术上相对粗糙，但为后来的产业奠定了基础。</p>
      
      <h2>发展期：1980年代</h2>
      <p>1980年代是日本成人动画的快速发展期。OVA（Original Video Animation）市场的蓬勃发展为成人动画提供了新的发行渠道。脱离了电视播出的内容限制，创作者获得了更大的表达自由。</p>
      <p>这一时期诞生了《奶油柠檬》等具有里程碑意义的作品系列，不仅在商业上取得了成功，也在一定程度上改变了社会对成人动画的认知。</p>
      
      <h2>黄金期：1990年代-2000年代</h2>
      <p>1990年代至2000年代被认为是日本成人动画的黄金时期。制作技术的成熟、市场规模的扩大以及社会接受度的提升，共同推动了成人动画产业的繁荣。</p>
      <p>《无颜之月》《夜勤病栋》《对魔忍》等经典作品均诞生于这一时期。制作公司在追求商业成功的同时，也开始注重作品的艺术品质与故事深度。</p>
      
      <h2>转型期：2010年代至今</h2>
      <p>互联网与流媒体技术的普及深刻改变了成人动画的消费方式。观众获取内容的渠道从实体媒介转向在线平台，这对传统的制作与发行模式产生了深远影响。</p>
      <p>同时，海外市场的拓展为日本成人动画产业带来了新的机遇与挑战。如何在全球化语境中保持日本成人动画的独特文化魅力，是业界面临的重要课题。</p>
      
      <h2>未来展望</h2>
      <p>随着VR、AI等新技术的发展，日本成人动画的内容形态与体验方式正在发生新的变革。技术与艺术的持续碰撞，将为这个有着半个世纪历史的产业注入新的活力。</p>
    `,
  },
  {
    id: 12,
    title: '2026年夏季新番里番推荐：最值得关注的五部作品',
    slug: '2026-summer-new-releases',
    category: '后宫系',
    categorySlug: 'harem',
    thumbnail: 'https://readdy.ai/api/search-image?query=Summer%20anime%20style%20illustration%20with%20vibrant%20colors%2C%20beach%20and%20sunset%20theme%2C%20energetic%20atmosphere%2C%20new%20season%20vibe%2C%20colorful%20fireworks%2C%20celebratory%20mood%2C%20clean%20modern%20anime%20aesthetic&width=800&height=500&seq=article-thumb-12&orientation=landscape',
    author: '夜桜编辑部',
    date: '2026-07-01',
    readTime: 7,
    excerpt: '2026年夏季里番新作陆续上线，本文从中精选五部最值得关注的作品，为你的暑期观影清单提供参考。',
    tags: ['新番推荐', '2026夏季', '新作', '观影指南'],
    featured: false,
    trending: true,
    content: `
      <h2>2026年夏季新番总览</h2>
      <p>2026年夏季，多部备受期待的里番新作陆续上线。本季度的作品在题材多样性上表现出色，涵盖了纯爱、奇幻、校园等多个热门分类。以下是经过编辑部精心筛选的五部最值得关注的作品。</p>
      
      <h3>1. 《夏日的尽头》——纯爱系</h3>
      <p>以海边小镇为舞台的夏日物语，制作阵容豪华，作画质量堪称本季最佳。细腻的情感描写与精致的画面表现力令人期待。</p>
      
      <h3>2. 《异世界魔王与七位新娘》——后宫系</h3>
      <p>异世界后宫题材的新作，在经典设定基础上加入了独特的魔法体系设计。角色个性鲜明，喜剧元素丰富。</p>
      
      <h3>3. 《魔法学园的禁忌》——奇幻系</h3>
      <p>以魔法学校为舞台的奇幻作品，世界观构建细致入微。剧情在魔法对决与角色关系之间取得了良好的平衡。</p>
      
      <h3>4. 《放课后的实验室》——校园系</h3>
      <p>以理科实验室为故事中心舞台的校园系新作，在传统校园题材中找到了新鲜的切入点。</p>
      
      <h3>5. 《星之彼方》——科幻系</h3>
      <p>融合太空探索与人工智能主题的科幻系力作，是本季度最具创新性的作品之一。</p>
    `,
  },
];

export const faqItems = [
  {
    question: '什么是里番动漫？它与普通日本动漫有什么区别？',
    answer: '里番动漫（裏番アニメ）是日本动画产业中的一个特殊分类，指面向成人观众制作、包含成人内容的动画作品。与在电视上播出的普通日本动漫不同，里番动漫通常以OVA、网络配信或以特定渠道发行的形式与观众见面，不受电视播出标准的限制，因此在内容表达上拥有更大的自由度。里番动漫在日本有着数十年的发展历史，形成了独特的制作体系、审美标准和文化生态。',
  },
  {
    question: '如何区分里番动漫的不同风格分类？',
    answer: '里番动漫的风格分类主要依据作品的题材、叙事方式和情感基调。常见的分类包括：纯爱系（以真挚情感为核心）、后宫系（多位异性角色与主角的互动）、奇幻系（以异世界或魔法等虚构设定为舞台）、校园系（以学校为故事背景）、百合系（专注女性角色间的情感）、NTR系（以感情背叛为叙事核心）、调教系（探索权力关系）以及科幻系（融合未来科技元素）。每类作品在视觉风格、叙事结构和情感表达上都有各自的特点，观众可以根据个人偏好选择。',
  },
  {
    question: '在哪里可以合法观看里番动漫？',
    answer: '合法的观看渠道主要包括：日本的DLsite、FANZA、DMM等数字内容平台，这些平台提供正版的里番动漫和漫画数字版购买与在线观看服务。部分作品也会通过特定的流媒体服务进行配信。我们始终建议观众通过正规渠道获取内容，支持创作者的劳动，同时也确保观看体验的质量与安全性。需要注意的是，不同平台的地区可用性可能存在差异，请根据所在地区的法律法规选择合适的获取方式。',
  },
  {
    question: '里番动漫和里番漫画有什么区别？',
    answer: '里番动漫是以动画形式呈现的成人向作品，具有配音、音乐和动态画面等动画特有的表现力。里番漫画则是以漫画（印刷品或数字形式）呈现的成人向作品，读者可以按照自己的节奏欣赏。两者在叙事方式和视觉体验上各有优势：动画通过动态画面和声音营造沉浸感，而漫画则让读者能够更加自由地控制阅读节奏，仔细品味画面的每一个细节。很多里番动漫改编自里番漫画原作，因此两个领域有着密切的联系。',
  },
  {
    question: '里番动漫的制作水准如何？与主流商业动画相比怎样？',
    answer: '里番动漫的制作水准因作品而异，差异较大。顶级里番制作公司如Lilith、Pixy等出品的作品，在作画质量、配音表现和音乐制作上可以达到很高的水准，甚至不亚于部分主流深夜动画。但总体来说，由于里番动漫的市场规模和制作预算通常小于主流商业动画，平均制作水准可能略低于主流作品。然而，近年来随着数字制作工具的普及和部分制作公司对品质的重视，里番动漫的整体制作水准呈现出稳步提升的趋势。',
  },
  {
    question: '日本成人动漫文化的历史是怎样的？',
    answer: '日本成人动漫文化可以追溯到1970年代。在录像带技术普及的推动下，面向成人观众的小规模动画制作开始出现。1980年代，OVA市场的蓬勃发展为成人动画提供了新的发行渠道，诞生了《奶油柠檬》等里程碑式作品系列。1990年代至2000年代被认为是黄金时期，制作技术成熟，市场规模扩大。2010年代以来，互联网与流媒体技术深刻改变了消费方式，同时海外市场的拓展为产业带来了新的机遇与挑战。经过半个世纪的发展，日本成人动漫已经形成了独特的文化生态和产业体系。',
  },
  {
    question: '如何看待里番动漫中的成人内容？',
    answer: '里番动漫中的成人内容是其作为特定类型作品的组成部分。我们认为，应当以理性的态度看待这类内容：一方面，承认其作为成人娱乐产品的定位；另一方面，也要认识到优秀的里番作品在成人内容之外，往往包含着精心构建的故事、立体的人物塑造和独特的艺术表达。关键在于选择适合自己审美偏好和接受程度的作品，并在合法合规的前提下进行消费。同时，我们始终强调，任何成人内容都应当在适当的年龄限制和法律框架内被接触和讨论。',
  },
  {
    question: '这个网站提供里番动漫的下载或在线观看吗？',
    answer: '本网站是一个内容导航与资讯推荐平台，专注于为成年用户提供里番动漫/漫画领域的精选作品推荐、风格分类解析、创作背景介绍以及合规观看渠道指引。我们自身不提供任何里番动漫内容的下载或在线观看服务。我们的目标是帮助用户了解日本成人动漫文化，发现值得关注的作品，并指引用户通过正规合法的渠道获取感兴趣的内容。',
  },
];

export const heroSlides = [
  {
    title: '探索里番动漫的艺术世界',
    subtitle: '深度解析日本成人动画的文化脉络与创作美学',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20abstract%20Japanese%20style%20illustration%20with%20flowing%20ink%20and%20crimson%20brush%20strokes%2C%20elegant%20composition%2C%20traditional%20meets%20modern%20aesthetic%2C%20minimalist%20design%2C%20sophisticated%20dark%20and%20warm%20tone%20contrast%2C%20calligraphy%20inspired%20abstract%20art&width=1600&height=800&seq=hero-slide-01&orientation=landscape',
  },
  {
    title: '2026夏季新番 · 精选推荐',
    subtitle: '编辑部精心甄选五部最受期待的夏季新作',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20abstract%20Japanese%20aesthetic%20composition%20with%20golden%20and%20vermilion%20textures%2C%20flowing%20silk%20like%20patterns%2C%20warm%20summer%20atmosphere%2C%20artistic%20minimalist%20design%2C%20soft%20gradients%2C%20sophisticated%20cultural%20art&width=1600&height=800&seq=hero-slide-02&orientation=landscape',
  },
  {
    title: '里番漫画经典 · 深度解读',
    subtitle: '从如月群真到TYPE.90，不可错过的漫画名作',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20abstract%20composition%20with%20Japanese%20aesthetic%2C%20ink%20wash%20painting%20style%2C%20deep%20crimson%20and%20charcoal%20tones%2C%20flowing%20brush%20textures%2C%20elegant%20minimalist%20design%2C%20cultural%20heritage%20atmosphere&width=1600&height=800&seq=hero-slide-03&orientation=landscape',
  },
];

export const siteInfo = {
  name: '夜桜导航',
  tagline: '里番动漫 漫画 | 精选内容推荐与资源导航',
  description: '专注于里番动漫/漫画领域的內容导航平台，为成年用户提供精选作品推荐、风格分类解析、创作背景介绍及合规观看渠道指引。帮助您快速找到感兴趣的里番动漫/漫画内容，了解日本成人动漫文化的发展脉络与主流风格。',
  email: 'contact@yozakura-nav.example.com',
  founded: '2024',
  stats: {
    articles: '200+',
    categories: '8',
    visitors: '50万+',
  },
};